import axios  from 'axios';
import moment from "moment";

/**
 *
 * @param params params
 * @param {String} params.date_pickup Date of pickup
 * @param {String} params.date_return Date of return
 * @param {Boolean} params.is_delivery Is delivery
 *  @param {String} params.pickup_day Pickup day
 * @returns {Promise<*>}
 */
const get = async (params) =>{
    const response = await axios.get('/reservations/vue/resources/group_packages',{params});
    return response.data.data;
}

export default get;
